import React from 'react';
import Typed from 'react-typed';

const Hero = () => {
  return (
    <div className="text-white">
      <div className="max-w-[800px] mt-[-96px] w-full h-screen mx-auto text-center flex flex-col justify-center">
        <p className="text-[#00df9a] font-bold p-2">Виртуальный музей</p>
        <h1 className="md:text-7xl sm:text-6xl text-4xl font-bold md:py-6">
          Сокровища Беларуси.
        </h1>
        <div className="flex justify-center items-center">
          <Typed
            className="md:text-5xl sm:text-4xl text-xl font-bold md:pl-4 pl-2"
            strings={['Игровое', 'Обучающее', 'Позновательное']}
            typeSpeed={120}
            backSpeed={140}
            loop
          />
          <p className="md:text-5xl sm:text-4xl text-xl font-bold py-4">
            Приложение
          </p>
        </div>
        <p className="md:text-2xl text-xl font-bold text-gray-500">
          Пройди квест и получи сокровища
        </p>
        <a href="#" target="blank">
          <a href='https://disk.yandex.ru/d/6Xvpt5uaDgT5kA'><button className="bg-[#00df9a] w-[200px] rounded-md font-medium my-6 mx-auto py-3 text-black">
            Скачать
          </button></a>
        </a>
      </div>
    </div>
  );
};

export default Hero;
